







































































































import {Mixins, Component, Watch} from 'vue-property-decorator';
import Common from '@/components/term/mixins/Common';
import PageTitle from '@/components/common/PageTitle.vue';
import MallTabPlus from '@/components/common/MallTabPlus.vue';
import ContentBottom from '@/components/term/common/ContentBottom.vue';
import editor from '@/components/common/summernote/Index.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

@Component({
  components: {
    PageTitle,
    MallTabPlus,
    ContentBottom,
    editor,
    DateCalendar
  }
})
export default class PersonalInfo extends Mixins(Common) {
  @Watch('currentMallNo')
  private mallNoChange(): void {
    this.afterGetTerms();
  }

  private popInfo = {
    title: this.toI18n('TERMS_PERSONALINFO_POPINFO1'),
    // eslint-disable-next-line quotes
    introduction: this.toI18n('TERMS_PERSONALINFO_POPINFO2'),
    tableInfos: [
      {
        tag: 'th',
        tagItems: [{value: this.toI18n('TERMS_PERSONALINFO_POPINFO3')}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO4')}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO5')}]
      },
      {
        tag: 'td',
        tagItems: [{style: 'color:red;', value: '${companyName}'}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO6')}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO7')}]
      },
      {
        tag: 'td',
        tagItems: [{style: 'color:red;', value: '${termsStartDate}'}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO8')}, {value: this.toI18n('TERMS_PERSONALINFO_POPINFO9')}]
      }
    ]
  };
}
